<div [ngClass]="{'content-container table-comp standard-table-fix': isWizardComponent}">
  @if (isWizardComponent) {
    <div class="title">
      <mwp-text-translate text="Beneficiaries" jsonKey="beneficiaries" />
    </div>
  }
  <div [ngClass]="{'content': isWizardComponent}">
    <form [formGroup]="beneficiariesForm">
      <div [formArrayName]="beneficiaryListArrayName">
        <table>
          <thead>
            <tr [ngClass]="{'modal-tr': (isModal || isEnrollment)}">
              <th class="center-text" style="width: 6%;">
                <mwp-text-translate text="Include" jsonKey="include" />
              </th>
              <th class="">
                <mwp-text-translate text="First Name" jsonKey="firstName" />
              </th>
              <th class="">
                <mwp-text-translate text="Last Name" jsonKey="lastName" />
              </th>
              <th class="">
                <mwp-text-translate text="Relationship" jsonKey="relationship" />
              </th>
              <th class="center-text" style="width: 10%;">
                <mwp-text-translate text="Percentage" jsonKey="percentage" />
              </th>
              <th class="center-text" style="width: 7%;">
                <mwp-text-translate text="Primary" jsonKey="primary" />
              </th>
              <th class="center-text" style="width: 10%;">
                <mwp-text-translate text="Contingent" jsonKey="contingent" />
              </th>
            </tr>
          </thead>
          <tbody>
            @for (item of gridArrayControls; track item; let i = $index) {
              <tr class="has-controls" [ngClass]="{'modal-tr': (isModal || isEnrollment)}" [formGroupName]="i">
                <td class="center-control">
                  <mat-checkbox formControlName="isSelected" (change)="selectedGrid($event, i)"></mat-checkbox>
                </td>
                <td class="pe-2">
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="firstName">
                  </mat-form-field>
                </td>
                <td class="pe-2">
                  <mat-form-field appearance="outline">
                    <input matInput formControlName="lastName">
                  </mat-form-field>
                </td>
                <td class="pe-2">
                  <mat-form-field appearance="outline">
                    <mat-select id="relationship" name="relationship" formControlName="relationship">
                      @for (item of relationshipsList; track item) {
                        <mat-option [value]="item.value">
                          {{item.text}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </td>
                <td style="width: 14%;">
                  <mat-form-field appearance="outline">
                    <input matInput [formControlName]="percentageName" type="number" [min]="0" [max]="100" [attr.min]="0" [attr.max]="100">
                  </mat-form-field>
                </td>
                <td class="center-control">
                  <mat-checkbox formControlName="isPrimary" (change)="selectedPrimary($event, i)"></mat-checkbox>
                </td>
                <td class="center-control">
                  <mat-checkbox formControlName="isContingent" (change)="selectedContingent($event, i)">
                  </mat-checkbox>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </form>
    @if(isWizardComponent) {
      <div class="d-flex justify-content-end footer">
        <button class="mwp-button-save" (click)="addRow()">
          <mwp-text-translate text="Add New Beneficiary" jsonKey="addNewBeneficiary" />
        </button>
      </div>
    }
  </div>
  @if(!isWizardComponent) {
    <div class="d-flex justify-content-end m-3">
      <button class="mwp-button-save" (click)="addRow()">
        <mwp-text-translate text="Add New Beneficiary" jsonKey="addNewBeneficiary" />
      </button>
    </div>
  }
</div>
 
@if (isModal) {
  <div>
    <hr style="margin:0;" />
  </div>
}
@if (isWizardComponent) {
  <div class="p-3">
    <mwp-wizard-button-control [hideCancelButton]="hideWizardCancelButton" [isContinueDisabled]="beneficiariesForm.invalid" (emitComplete)="completeForm()" (emitCancel)="cancelForm()" />
  </div>
}
@if (!isWizardComponent) {
  <div class="d-inline-flex justify-content-end w-100">
    <button class="mwp-button-secondary m-3" (click)="cancelForm()">
      <mwp-text-translate text="Cancel" jsonKey="cancel" />
    </button>
    <button class="mwp-button-save m-3" [disabled]="beneficiariesForm.invalid || beneficiariesForm.pristine" (click)="completeForm()">
      <mwp-text-translate text={{saveButtonText}} jsonKey={{saveButtonText}} />
    </button>
  </div>
}